// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__3VUYo","title":"title__2PTG5","message":"message__54o-Z","link":"link__1lmkh"};